import { ChevronLeft, ChevronRight } from "lucide-react"
import type { PaginationState } from '@/features/fmo'

interface LoadBalancerPaginationProps {
  pagination: PaginationState
  totalItems: number
  onPageChange: (page: number) => void
}

export default function LoadBalancerPagination({ 
  pagination, 
  totalItems, 
  onPageChange 
}: LoadBalancerPaginationProps) {
  const { currentPage, itemsPerPage, totalPages } = pagination
  const startIndex = (currentPage - 1) * itemsPerPage

  if (totalPages <= 1) return null

  return (
    <div className="p-6 border-t border-gray-200 flex items-center justify-between">
      <div className="text-sm text-gray-600">
        Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, totalItems)} of {totalItems} configurations
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
          className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <span className="px-4 py-2 text-sm font-medium">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  )
}
